import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import "../../../assests/css/studentdashboard/StudentNotification.css";
import StudentsideLayout from "../../../layouts/StudentsideLayout";
import { AppContext } from "../../../context/Appcontext";
import { Bell, CheckCheck } from "lucide-react";
import Swal from "sweetalert2";

const StudentNotification = () => {
  const { baseUrl } = useContext(AppContext);
  const [errorMessage, setErrorMessage] = useState('');

  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  // Student data from localStorage
  const studentData = JSON.parse(localStorage.getItem("student"));

  useEffect(() => {
    viewAllNotification();
  }, []);
  const viewAllNotification = () => {
    setLoading(true);
    const formData = new FormData();
formData.append("ngstudent_id", studentData?.id);
    axios.post(`${baseUrl}/student/notification/viewAllNotification`, formData, {
      headers: {
        // "Authorization": `Bearer ${authToken}`
        "Content-Type": "multipart/form-data"
      }
    })
      .then((response) => {
        console.log(response.data);
        if (response.data.success == true) {
          setNotifications(response.data.notifications)
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  // const fetchNotifications = async () => {
  //   try {
  //     setLoading(true);

  //     const response = await axios.get(
  //       `${baseUrl}/api/student/notifications/viewAllNotifications`,
  //       {
  //         params: {
  //           student_id: studentData?.id,
  //         },
  //       }
  //     );

  //     if (response.data?.notifications) {
  //       setNotifications(response.data.notifications);
  //     } else {
  //       setNotifications([]);
  //     }
  //   } catch (error) {
  //     console.error("Notification Fetch Error:", error);
  //     setNotifications([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const markAsRead = (item) => {
    const formData = new FormData();
    formData.append('id', item.id);
    axios.post(`${baseUrl}/student/notification/markAsRead`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        // "Authorization": `Bearer ${authToken}`
      },
    })
      .then((response) => {
        console.log("response called", response.data);
        if (response.data.success == true) {
          // ── Sirf us notification ki isRead true karo ──
          setNotifications(prev =>
            prev.map(n => n.id === item.id ? { ...n, isRead: true } : n)
          );
        }
        else if (response.data.success == false) {
          setErrorMessage(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const markAllAsRead = () => {
   const formData = new FormData();
formData.append("ngstudent_id", studentData?.id);
    axios.post(`${baseUrl}/student/notification/markAllAsRead`, formData, {
      headers: {
        // "Authorization": `Bearer ${authToken}`
       "Content-Type": "multipart/form-data"
      }
    })
      .then((response) => {
        console.log("response called", response.data);
        if (response.data.success == true) {
          // ── Sab notifications ki isRead true karo ──
          // setNotifications(prev => prev.map(n => ({ ...n, isRead: true })));
          viewAllNotification();
          Swal.fire({
            icon: 'success',
            title: 'Done',
            text: 'All Notification Marked as Read',
            confirmButtonText: 'Okay'
          })
        }
        else if (response.data.success == false) {
          setErrorMessage(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <StudentsideLayout>
      <div className="spn-wrapper">
        <div className="spn-header">
          <h2 className="spn-heading">Notifications</h2>

          <div className="spn-badge">
            <Bell size={18} />
            <span>{notifications.length}</span>
          </div>
        </div>
        <div>
          <button
            className="adm-notif-page__action-btn adm-notif-page__action-btn--secondary"
            onClick={markAllAsRead}
          >
            <CheckCheck size={18} />
            <span>Mark All as Read</span>
          </button>
          {/* <span className="tp-notify-read">
              Mark all as read
            </span> */}
        </div>

        {loading ? (
          <div className="spn-empty">
            <p>Loading notifications...</p>
          </div>
        ) : notifications.length === 0 ? (
          <div className="spn-empty">
            <p>No notifications available</p>
          </div>
        ) : (
          <div className="spn-list">
            {notifications.map((item) => (
              <div
                key={item.id}
                className={`spn-card ${item.isRead == 0 ? "spn-unread" : ""
                  }`}
              >
                <div className="spn-card-left">
                  <h4 className="spn-title">
                    {item.title || "Notification"}
                  </h4>

                  <p className="spn-message">
                    {item.message}
                  </p>
                </div>

                <div className="spn-card-right">
                  <span className="spn-time">
                    {item.created_at
                      ? new Date(item.created_at).toLocaleDateString()
                      : "Recently"}
                  </span>

                  {item.isRead == 0 && (
                    <span className="spn-dot"></span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </StudentsideLayout>
  );
};

export default StudentNotification;